import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import OnDemandLiveRegion from 'on-demand-live-region';

const PageTitle = ({ titleString }) => {
  useEffect(() => {
    const liveRegion = new OnDemandLiveRegion();
    liveRegion.say(titleString);
  }, [titleString]);

  return (
    <Helmet>
      <title>{titleString}</title>
    </Helmet>
  );
};

PageTitle.defaultProps = {
  titleString: PropTypes.string.isRequired,
};

PageTitle.defaultProps = {
  titleString: '',
};

export default PageTitle;
